import { defaultAgent, apiResponse } from '../helpers/web-agent';
import * as actionTypes from '../constants/action-types';
import { toastInfo, toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { PERSONAL_CREATED, PERSONAL_EDITED, PERSONAL_DELETED } from '../constants/messages';
import { getSearchDateRange } from '../helpers/common';

export const personListRequest = () => {
    return { type: actionTypes.GET_PERSON_LIST_REQUEST };
}

export const operatorListRequest = () => {
    return { type: actionTypes.GET_OPERATOR_LIST_REQUEST };
}

export const stateList = (data = []) => {
    return { type: actionTypes.GET_STATE_LIST, payload: data };
}

export const countryList = (data = []) => {
    return { type: actionTypes.GET_COUNTRY_LIST, payload: data };
}

export const operatorList = (data = []) => {
    return { type: actionTypes.GET_OPERATOR_LIST, payload: data };
}

export const personList = (data = []) => {
    return { type: actionTypes.GET_PERSON_LIST, payload: data };
}

export const personInfo = (data = []) => {
    return { type: actionTypes.GET_PERSON_INFO, payload: data };
}

export const personConfig = (data = null) => {
    return { type: actionTypes.GET_PERSON_CONFIG, payload: data };
}

export const clearOperatorList = () => ({ type: actionTypes.CLEAR_OPERATOR_LIST });

export const getPersonConfig = (cb = null) => {
    return dispatch => {
        defaultAgent.get('/api/person/config')
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.data) {
                    dispatch(personConfig(agentResult.data));
                    if (cb) cb();
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(personConfig());
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(personConfig());
            });
    }
}

export const createPerson = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/person/add', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === PERSONAL_CREATED.code) {
                    if (cb) cb(true);
                    dispatch(toastSuccess(agentResult.message));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                if (cb) cb(false);
                dispatch(toastError(ex.message));
            });
    }
}

export const editPerson = (data, cb) => {
    return dispatch => {
        defaultAgent.put('/api/person/edit', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === PERSONAL_EDITED.code) {
                    if (cb) cb(true);
                    dispatch(toastSuccess(agentResult.message));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                if (cb) cb(false);
                dispatch(toastError(ex.message));
            });
    }
}

export const deletePerson = (data, cb) => {
    return dispatch => {
        defaultAgent.put('/api/person/v1/delete', { person_uuid: data.person_uuid, farm_uuid: data.farm_uuid })
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === PERSONAL_DELETED.code) {
                    if (cb) cb(true);
                    dispatch(toastInfo(agentResult.message));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                if (cb) cb(false);
                dispatch(toastError(ex.message));
            });
    }
}

export const getOperatorList = (params) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        role: "operator"
    };

    dispatch(operatorListRequest());
    defaultAgent.get('/api/person/v1/name/list', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(operatorList());
            } else if (agentResult.data) {
                dispatch(operatorList(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(operatorList());
        });
}

export const getPersonList = (params) => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to
    };

    dispatch(personListRequest());
    defaultAgent.get('/api/person/v1/list', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(personList());
            } else if (agentResult.data) {
                dispatch(personList(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
            dispatch(personList());
        });
}

export const getPersonInfo = (data) => {
    return dispatch => {
        defaultAgent.get('/api/person/info', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.data) {
                    dispatch(personInfo(agentResult.data));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(personInfo());
                }
            }).catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(personInfo());
            });
    }
}

export const getStateList = (data) => {
    return dispatch => {
        defaultAgent.get('/api/person/state', data)
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                }
                else if (agentResult.data) {
                    dispatch(stateList(agentResult.data));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(stateList());
                }
            })
            .catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(stateList());
            });
    }
}

export const getCountryList = (data) => {
    return dispatch => {
        defaultAgent.get('/api/person/country', data)
            .then(res => {
                const agentResult = apiResponse(res, []);
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                }
                else if (agentResult.data) {
                    dispatch(countryList(agentResult.data));
                } else if (agentResult.message) {
                    dispatch(toastError(agentResult.message));
                    dispatch(countryList());
                }
            })
            .catch(ex => {
                dispatch(toastError(ex.message));
                dispatch(countryList());
            });
    }
}